import { GET_USER_LIST } from '@/dataSource/api/Contact/apiContact'
import { defineStore } from 'pinia'
import { ShowPerPage } from "@/stores/showPerPage/showPerPage"
import { getIndexedDB, setIndexedDB } from '@/dataSource/indexed-DB/indexedDB'
import router from '@/router'
import { removeCodeMobile } from '../RemoveCodeMobile'
import { siteUrlApiUpload } from '@/main'
import { ListPlacePhone } from '../PlacePhone/ListPlacePhone'
import { ListNotif } from '../Notif/ListNotif'


interface PageInt {
    numPage: number
    statusNextPage: Boolean
}
interface SearchType {
    dataSearch: any
    loadingSearch: Boolean
}

interface errMessage {
    errMessage: string
    showCardMessage: Boolean
}
interface successMessage {
    successMessage: string
    showCardMessage: Boolean
}
interface ContactType {
    search: SearchType
    PageInt: PageInt
    dataList: any
    result: any
    alphabet: any
    sortUserData: any
    loading: Boolean
    emptyList: boolean
    usersCount: number
    err: errMessage
    success: successMessage
    placephoneList : any
    notifList : any
}
export const ContactList = defineStore('ContactList', {
    state: () => <ContactType>({
        search: {
            dataSearch: "",
            loadingSearch: false
        },
        PageInt: {
            numPage: 1,
            statusNextPage: false
        },
        result: [],
        dataList: [],
        alphabet: [],
        sortUserData: [],
        loading: false,
        emptyList: false,
        usersCount: NaN,
        err: {
            errMessage: '',
            showCardMessage: false
        },
        success: {
            successMessage: '',
            showCardMessage: false
        },
        placephoneList : ListPlacePhone(),
        notifList : ListNotif(),
    }),
    actions: {

        async checkStatusUser() {
            if (window.navigator.onLine) {
                await this.handelData()
                if (!await getIndexedDB('list-placephone')) {
                    setTimeout(() => {
                        this.placephoneList.handelData()
                    }, 2000)
                }
                if(!await getIndexedDB('list-notif')) {
                    setTimeout(() => {
                        this.notifList.handelData()
                    }, 2000)
                }

            } else {
                this.handelOfflineList()
            }
        },

        async handelOfflineList() {
            this.dataList = await getIndexedDB('list-contact')
            this.dataList = JSON.parse(this.dataList)
            this.checkEmptyList()
            this.handelSortData()
        },

        async handelSearchOffile(search?: string) {
            if (search) {
                this.dataList = await getIndexedDB('list-contact')
                this.dataList = JSON.parse(this.dataList)

                this.dataList = this.dataList.filter((item: any) => {
                    let mobile = removeCodeMobile(item.mobile)
                    Object.defineProperty(item, 'fullInfo', {
                        value: item.firstName + ' ' + item.lastName + ' ' + mobile
                    })

                    return item.fullInfo.search(search) != -1

                })

                this.checkEmptyList()
                this.handelSortData()
            } else {
                this.handelOfflineList()
            }
        },

        async handelClickEventPage(nameRoute: string, userID?: number) {
            if (window.navigator.onLine) {
                if (userID) {
                    router.push({ name: nameRoute, params: { id: userID } })
                } else {
                    router.push({ name: nameRoute })
                }
            } else {
                this.err.showCardMessage = true
                this.err.errMessage = 'شما آفلاین هستید .'
                setTimeout(() => {
                    this.err.showCardMessage = false
                    this.err.errMessage = ''
                }, 2000)
            }
        },


        async handelPageInt() {
            if (!this.PageInt.statusNextPage && this.result.data.users.length == ShowPerPage) {
                if (window.innerHeight + window.pageYOffset + 200 >= document.body.offsetHeight) {
                    this.PageInt.numPage++
                    this.PageInt.statusNextPage = true
                    this.handelData(this.PageInt.numPage)
                }
            }
        },
        async handelData(page?: any) {
            if (page) {
                this.result = await GET_USER_LIST(page)
            }
            else {
                this.loading = true
                this.PageInt.numPage = 1
                this.result = await GET_USER_LIST()
            }
            this.handelDataList()
            this.checkEmptyList()
            const avatar = this.dataList[5].avatar
            const url = siteUrlApiUpload + avatar
            const img = new Image()
            img.src = url
            // img.onload = () => {

            // }
        },
        async handelDataList() {
            this.usersCount = this.result.data.usersCount
            if (this.PageInt.statusNextPage && this.PageInt.numPage > 1) {
                this.dataList = this.dataList.concat(this.result.data.users)
            } else {
                this.dataList = []
                this.dataList = this.result.data.users
            }
            await setIndexedDB('list-contact', JSON.stringify(this.dataList))
            this.PageInt.statusNextPage = false
            this.loading = false
            this.handelSortData()
        },

        async handelSerachList(search: any) {
            this.loading = true
            this.PageInt.numPage = 1
            this.PageInt.statusNextPage = false
            this.result = await GET_USER_LIST(this.PageInt.numPage, search)
            this.handelSearch()
        },
        async handelSearch() {
            this.dataList = this.result.data.users
            this.loading = false
            this.checkEmptyList()
            this.handelSortData()
        },

        async handelSortData() {
            this.alphabet = []
            this.sortUserData = []
            await this.dataList.forEach((data: any) => {

                this.alphabet.push(
                    data.lastName.split('')[0]
                )
                this.alphabet = this.alphabet.filter((i: any, index: number) => {
                    return this.alphabet.indexOf(i) === index;
                });


            });

            for (let i = 0; i < this.alphabet.length; i++) {
                this.sortUserData.push(this.dataList.filter((item: any) => {
                    return this.alphabet[i] == item.lastName.charAt(0)
                }))
            }
        },

        async checkEmptyList() {
            if (this.dataList.length == 0) {
                this.emptyList = true
            } else {
                this.emptyList = false
            }
        }
    }

})